import { Link } from 'react-router-dom';

export default function ToolsCta() {
  return (
    <section className="bg-[#5C5470] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left */}
          <div className="text-center lg:text-left max-w-xl">
            <p className="text-[#D4A373] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
              NEXT STEP
            </p>
            <h2
              className="font-serif font-bold text-white mb-5"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              工具可以幫您整理現況，
              <br />
              顧問可以幫您看懂下一步
            </h2>
            <p className="text-white/75" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              下載工具後，若需要協助解讀，歡迎預約一對一諮詢。
              琮恩將根據您的實際狀況，提供最適合的保障建議。
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-4 flex-shrink-0 w-full lg:w-auto">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約諮詢
            </Link>
            <a
              href="https://lin.ee/6XFYSq2"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:border-white hover:bg-white/10 transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-line-fill"></i>
              加入 LINE 諮詢
            </a>
          </div>
        </div>

        {/* Bottom badges */}
        <div className="mt-16 pt-12 border-t border-white/15 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: 'ri-download-line', text: '免費下載所有工具' },
            { icon: 'ri-lock-line', text: '個資安全保護' },
            { icon: 'ri-customer-service-2-line', text: '專業顧問解讀協助' },
            { icon: 'ri-refresh-line', text: '工具持續更新優化' },
          ].map((b) => (
            <div key={b.text} className="flex items-center gap-3 text-white/75">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${b.icon} text-[#D4A373] text-xl`}></i>
              </div>
              <span style={{ fontSize: '1.0625rem' }}>{b.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
